import { ApiCompany } from "./company.model";
import { ApiModel } from "./model.model";

export class ApiContact extends ApiModel {
    Company: ApiCompany;
    company_ID: string;
    company_name: string;
    salutation: string;
    firstname: string;
    preferredname: string;
    lastname: string;
    type: string;
    sub_type: string;
    title: string;
    email: string;
    email2: string;
    work_phone1: string;
    work_phone2: string;
    home_phone1: string;
    home_phone2: string;
    mobile: string;
    fax: string;
    other_phone: string;
    work_address1: string;
    work_address2: string;
    work_city: string;
    work_state: string;
    work_zip: string;
    work_country: string;
    personal_address1: string;
    personal_address2: string;
    personal_city: string;
    personal_state: string;
    personal_zip: string;
    personal_country: string;
    notes: string;
    latitude: string;
    longitude: string;
    latitude_h: string;
    longitude_h: string;
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/contact.model.ts